

export default {
  namespaced: true,

  state: {
    filtro: {},
    fecha: 3,
    dispatchSearch: '',
    searchEnabled: true,

  },

  getters: {
    filtro (state) {
      return state.filtro
    },
    fecha (state) {
      return state.fecha
    },
    getDispatchSearch(state){
      return state.dispatchSearch;
    },
    searchEnabled(state){
      return state.enableSearch
    },
  },

  mutations: {
    SET_FILTRO (state, value) {
      state.filtro = value
    },
    SET_FECHA (state, value) {
      state.fecha = value
    },
    SET_DISPATCH_SEARCH(state,value){
      state.dispatchSearch = value;
    },
    SET_SEARCH(state, value){
      state.enableSearch = value;
    }
  },

  actions: {
  
    cambiarFiltro ({  commit }, tipo_filtro) {
      commit('SET_FILTRO', tipo_filtro)
    },
    cambiarFecha ({  commit }, fecha) {
      commit('SET_FECHA', fecha)
    },

    // SEARCH BAR STUFF..
    setDispatchSearch({ commit }, query){
      commit('SET_DISPATCH_SEARCH', query);
    },
    enableSearch({ commit }, value){
      commit('SET_SEARCH', value);
    }
  }
} 